export let FlexBoxWrap = /*#__PURE__*/function (FlexBoxWrap) {
  FlexBoxWrap["NoWrap"] = "NoWrap";
  FlexBoxWrap["Wrap"] = "Wrap";
  FlexBoxWrap["WrapReverse"] = "WrapReverse";
  return FlexBoxWrap;
}({});